import { connect } from 'react-redux';
import SessionFeedback from './SessionFeedback';

const mapStateToProps = state => ({
  user: state.user,
});

export default connect(mapStateToProps)(SessionFeedback);
